import styled, { css } from 'styled-components';

function createResponsiveCSS() {
	let styles = '';
	const deviceBreakpoints = {
		xs: 1,
		sm: 576,
		md: 768,
		lg: 992,
		xl: 1200,
	}

	const arr = Array.from({length: 10}, (_, i) => i + 1);
	arr.push('auto')

	Object.keys(deviceBreakpoints).forEach(type => {
		arr.forEach(item => {
			let width = '';
			if (item === "auto") {
				width = "auto";
			} else {
				width = `calc(100% * (${item} / 12))`;
			}
			styles += `
			&.biz-col-${type}-${item} {
				@media (min-width: ${deviceBreakpoints[type]}px) {
					width: ${width};
				}
			}`
		})
  });

  return css`${styles}`;
  }

export const ContainerWrapper = styled.div`
    --gap: ${props => props.spacing ? (props.spacing * 8) / 2 : 0}px;
    display: flex;
    box-sizing: border-box;
    flex-direction: ${props => props.direction || 'row'};
    flex-wrap: ${props => props.wrap || 'wrap'};
    justify-content: ${props => props.justify || 'flex-start'};
    align-items: ${props => props.alignItems || 'stretch'};
    align-content: ${props => props.alignContent || 'stretch'};
    margin: calc(-1 * var(--gap)) 0 0 calc(-1 * var(--gap));
    width: calc(100% + var(--gap));
    & .gridItem {
        padding: var(--gap) 0 0 var(--gap);
    }
`;

export const ItemWrapper = styled.div`
    box-sizing: border-box;
    width: 100%;
    ${createResponsiveCSS()}
`;
